import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import edColors from './ED';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary = {
  '10': '#F7FCF5',
  '20': '#F0FAEB',
  '30': '#66C431',
  '50': '#2D7D00',
  '70': '#215C00',
  '80': '#123300',
  '90': '#123300',
};

// TODO: This colors should be defined. For backward-compatibility they are the same as eDreams but it's wrong.
const secondary = edColors.secondary;

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
